module.exports = __webpack_public_path__ + "img/s1.6bc71272.png";